import React from 'react';
import useFolderStructure from '../../../hooks/useFolderStructure';
import FolderStructure from './FolderStructure';
import { getCustomizedStructure } from 'utils/common';
import ComponentTraceLoader from 'components/ComponentTraceLoader';
export default function WrapperFolderStructure({ artefactContentStructure }) {
  const {
    activeEventKey,
    setActiveEventKeyAccordian,
    folderStructure,
    handleFolderClick,
    downloadArtefactLink,
  } = useFolderStructure({ artefactContentStructure });
  if (artefactContentStructure?.loading) {
    return <ComponentTraceLoader type="STAGE_LIST" />;
  }
  return (
    <div className="ltw-mt-10px folder-structure-wrapper">
      <FolderStructure
        folderStructure={getCustomizedStructure(folderStructure)}
        activeEventKey={activeEventKey}
        setActiveEventKeyAccordian={setActiveEventKeyAccordian}
        handleFolderClick={handleFolderClick}
        downloadArtefactLink={downloadArtefactLink}
      />
    </div>
  );
}
